<template>
	<form class="recommend" @submit.prevent="register">
		<ManagingSection>
			<ManagingBox title="순서">
				<input
					type="number"
					v-model="sort"
					min="0"
					class="recommend__sort"
				/>
			</ManagingBox>
			<ManagingBox title="추천브랜드명">
				<input type="text" v-model="adminTitle" />
				<p class="recommend__explain">
					내부 관리를 위한 제목 입력란입니다.(유저에게 미노출)
				</p>
			</ManagingBox>
			<ManagingBox title="타이틀">
				<TextCounter
					v-model="promotionTitle"
					:useTextarea="true"
					:rows="2"
					:useLineLimit="true"
					:maxLength="25"
					:useComma="true"
				/>
			</ManagingBox>
			<ManagingBox title="디스크립션">
				<TextCounter
					v-model="description"
					:useTextarea="true"
					:rows="2"
					:useLineLimit="true"
					:maxLength="25"
					:useComma="true"
				/>
			</ManagingBox>
			<ManagingBox title="브랜드">
				<SearchBrand ref="searchBrand" @change="setBrand($event)" />
			</ManagingBox>
			<ManagingBox title="노출기간">
				<DateRange v-model="datePeriod" ref="datePeriod" />
			</ManagingBox>
			<ManagingBox title="링크종류">
				<select class="select" v-model="linkType">
					<option
						v-for="item in linkTypeList"
						:key="item.id"
						:value="item.id"
					>
						{{ item.name }}
					</option>
				</select>
			</ManagingBox>
			<ManagingBox title="링크값">
				<input type="text" v-model="linkValue" />
			</ManagingBox>
			<ManagingBox title="제품">
				<ProductSearcher2
					class="recommend__product"
					@change="addProduct"
				/>
				<div class="recommend__product-name" v-if="productName">
					<span v-html="productName"></span>
					<button
						class="recommend__product-name remove"
						@click="removeProduct"
					>
						<i class="fa fas fa-minus"></i>
					</button>
				</div>
			</ManagingBox>
			<ManagingBox title="프로모션이미지">
				<ImageUploader
					ref="imageUploader"
					group="brand-img"
					:image-size-limit="{
						previewWidth: 300,
						width: 1080,
						height: 1350,
						type: 'fit',
					}"
					:file-path-has-slash="true"
					@upload="onImageUpload($event, '1080x1350')"
					:image-src="brandImagePath"
					@cancel="onImageCancel"
				/>
				<p class="recommend__explain">
					- 파일형식: PNG(*.png), JPEG(*.jpg)<br />
					- 사이즈 : 1080 x 1350
				</p>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button
				type="submit"
				class="btn-main blue"
				v-text="mode === 'register' ? '등록' : '수정'"
			/>
			<button
				type="button"
				class="btn-main"
				v-text="'취소'"
				@click="rewrite"
			/>
		</div>
	</form>
</template>
<script>
	import moment from 'moment';
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import TextCounter from '@/components/TextCounter.vue';
	import DateRange from '@/components/DateRange';
	import { mapGetters } from 'vuex';
	import ImgSelector from '@/components/ImgSelector.vue';
	import SearchBrand from '@/components/SearchBrand';
	import ImageUploader from '@/components/ImageUploader';
	import { imageRemove } from '@/util';
	import ProductSearcher2 from '@/components/ProductSearcher2';

	export default {
		name: 'ReviewDetail',
		components: {
			ManagingSection,
			ManagingBox,
			DateRange,
			TextCounter,
			ImgSelector,
			SearchBrand,
			ImageUploader,
			ProductSearcher2,
		},
		props: {
			mode: {
				type: String,
				default: 'register',
			},
		},
		data() {
			return {
				description: '',
				linkType: null,
				linkValue: '',
				promotionTitle: '',
				datePeriod: { from: '', to: '' },
				idBrand: 0,
				adminTitle: '',
				sort: 1,
				fileDir: '',
				fileSaveName: '',
				brandImagePath: '',
				prevImagePath: '',
				productName: '',
				idProduct: 0,
			};
		},
		computed: {
			...mapGetters(['getListAddNull']),
			linkTypeList() {
				return this.getListAddNull('newLinkType');
			},
		},
		created() {
			if (this.$route.params.idParam) {
				this.getList(this.$route.params.idParam);
			}
		},
		methods: {
			validation() {
				if (!this.adminTitle) {
					alert('타이틀을 입력해주세요');
					return false;
				}

				if (!this.promotionTitle) {
					alert('프로모션 타이틀을 입력해주세요');
					return false;
				}

				if (!this.description) {
					alert('프로모션 설명을 입력해주세요');
					return false;
				}

				if (!this.idBrand) {
					alert('브랜드를 입력해주세요');
					return false;
				}

				if (!this.datePeriod.from) {
					alert('노출기간 시작일을 설정해주세요');
					return false;
				}

				if (!this.datePeriod.to) {
					alert('노출기간 종료일을 설정해주세요');
					return false;
				}

				if (
					moment(this.datePeriod.from).valueOf() >
					moment(this.datePeriod.to).valueOf()
				) {
					alert('종료일이 시작일보다 이전날짜입니다');
					return false;
				}

				if (!this.linkType) {
					alert('링크타입을 설정해주세요');
					return false;
				}

				if (!this.linkValue) {
					alert('링크값을 입력해주세요');
					return false;
				}

				if (!this.productName) {
					alert('제품을 넣어주세요');
					return false;
				}

				if (!this.fileDir || !this.fileSaveName) {
					alert('이미지를 넣어주세요');
					return false;
				}

				return true;
			},
			async getList(id) {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`v3/api/brand/recommendModule/${id}`
					);
					this.adminTitle = data.adminTitle;
					this.datePeriod.to = moment
						.unix(data.endAt)
						.format('YYYY-MM-DD HH:mm');
					this.datePeriod.from = moment
						.unix(data.startAt)
						.format('YYYY-MM-DD HH:mm');
					this.description = data.description;
					this.promotionTitle = data.title;
					this.linkType = data.linkType;
					this.linkValue = data.linkValue;
					this.idBrand = data.idBrand;
					// this.$refs.idProduct.selecting(data.idProduct, data.productTitle);
					this.idProduct = data.idProduct;
					this.productName = data.productTitle;
					this.$refs.searchBrand.setBrand(
						data.idBrand,
						data.brandTitle
					);
					this.brandImagePath = data.imgUrl;
					this.prevImagePath = data.imgUrl;
					this.getFileName(data.imgUrl);
					this.sort = data.sort;
				} catch (err) {
					console.error(err);
					alert(
						'리스트를 불러오는데 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
			async register() {
				if (!this.validation()) return false;
				const params = {
					id: Number(this.$route.params.idParam) || '',
					title: this.promotionTitle,
					description: this.description,
					fileDir: this.fileDir,
					fileSaveName: this.fileSaveName,
					startAt: moment(this.datePeriod.from).valueOf(),
					endAt: moment(this.datePeriod.to).valueOf(),
					linkType: this.linkType,
					linkValue: this.linkValue,
					idBrand: this.idBrand,
					idProduct: this.idProduct,
					sort: this.sort,
					adminTitle: this.adminTitle,
				};

				if (
					this.mode === 'modify' &&
					this.brandImagePath !== this.prevImagePath
				) {
					const imageHost = `${this.$store.state.env.IMAGE_STORAGE_PATH}`;
					imageRemove(this.prevImagePath.split(imageHost).pop());
				}

				try {
					await this.$axiosAdmin2.post(
						'/v3/api/brand/recommendModule',
						params
					);
					alert(
						`${this.mode === 'register' ? '등록' : '수정'}하였습니다.`
					);
					this.$router.push('/advertisement/brand-recommend');
				} catch (err) {
					console.error(err);
					alert(
						`${this.mode === 'register' ? '등록' : '수정'}에 실패했습니다. 계속해서 문제 발생시 개발팀에 문의해주세요`
					);
				}
			},
			rewrite() {
				if (!confirm('다시 작성하시겠습니까?')) return;
				this.description = '';
				this.promotionTitle = '';
				this.$refs.saveImage.init();
				this.$refs.idProduct.cancelSelecting();
				this.linkType = null;
				this.linkValue = '';
				this.datePeriod.to = '';
				this.datePeriod.from = '';
				this.idBrand = 0;
				this.$refs.searchBrand.init();
			},
			setBrand(event) {
				if (event) {
					this.idBrand = event.idBrand;
				}
			},
			addProduct(item) {
				this.productName = item.name;
				this.idProduct = item.idProduct;
			},
			removeProduct() {
				this.idProduct = 0;
				this.productName = '';
			},
			onImageUpload(event) {
				const imageHost = `${this.$store.state.env.IMAGE_STORAGE_PATH}`;
				if (!Object.keys(event).length) return;
				this.fileDir = event.fileDir;
				this.fileSaveName = event.fileSaveName;
				this.brandImagePath = `${imageHost}${event.fileDir}/${event.fileSaveName}`;
			},
			getFileName(name) {
				const imageHost = `${this.$store.state.env.IMAGE_STORAGE_PATH}`;
				const file = name.split('/').reverse();
				this.fileSaveName = file[0];
				this.fileDir = name
					.replace(`/${this.fileSaveName}`, '')
					.replace(`${imageHost}`, '');
			},
			onImageCancel(key) {
				if (this.mode === 'register') {
					imageRemove(key);
					this.brandImagePath = '';
					this.fileDir = '';
					this.fileSaveName = '';
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.recommend__sort {
		width: 100px !important;
	}
	.recommend__product {
		width: 60%;
	}
	.recommend__explain {
		margin-top: 10px;
	}
	.recommend__product-name {
		width: 60%;
		margin: 20px 0;
		&.remove {
			background: #ff3860;
			font-size: 0.75rem;
			vertical-align: middle;
			width: 1.6em;
			height: 1.6em;
			border-radius: 50%;
			color: #fff;
			margin: 0 0 0 10px;
		}
	}
</style>
